import { Common } from '@thecvlb/design-system/lib/src';

import { IntroProps } from './intro.types';

import tirzepatide from 'assets/images/medications/tirzepatide-square.webp';

const Intro: React.FC<IntroProps> = ({ onContinue, isGoodPrice }) => {
  return (
    <div className="flex h-full flex-col">
      <div className="flex flex-col items-center gap-2 py-6 text-center">
        <div>
          <img
            alt="tirzepatide"
            className="size-[96px] rounded-full object-cover"
            src={tirzepatide}
          />
        </div>
        <h4 className="text-m2xl font-bold text-primary-700 md:text-2xl">
          Let’s confirm your personalized medication!
        </h4>
        <p>
          If you want to continue with compounded semaglutide, you may qualify for a personalized
          compound by confirming other health conditions.
        </p>
        <p className="font-bold">
          Please complete the following survey (~1 minute) to assist your provider’s evaluation of
          your eligibility for a personalized compound in support of your weight loss goals.
        </p>
        {isGoodPrice && (
          <Common.Alert type="info" colorableBackground>
            <p className="text-left">
              If preferred, review your prescription benefits for brand name GLP-1 medications in
              the Weight section of the portal before progressing.
            </p>
          </Common.Alert>
        )}
      </div>
      <Common.Button
        className="py-6 max-md:mt-auto md:self-center"
        color="blue"
        fullWidthOnMobile
        onClick={onContinue}
      >
        Continue
      </Common.Button>
    </div>
  );
};

export default Intro;
